// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__EpxDe","line":"styles_line__6OmY_","name":"styles_name__1aQI8","body":"styles_body__j8QLa","footer":"styles_footer__YYF31","button":"styles_button__gkpOk"};